import { NavButton } from "./Buttons";

export function PageHeader({ pageTitle, navPath}: { pageTitle: string, navPath?: string }) {
    return (
        <div  className="page-header my-2 my-md-3 p-2 p-md-3 fw-bold rounded border border-1 border-success text-success d-flex flex-row justify-content-between align-items-center">
            <h1 className="h5 h3-md mb-0">{pageTitle}</h1>
            <NavButton path={navPath ?? ''}/>
        </div>
    );
}
